(() => {
  /* ================== CSS (kafelek) ================== */
  const STYLE = `
html.itb-hide-amp-gift #slidecarthq .free-gifts .free-gifts-body .slick-wrapper{display:none!important}

#slidecarthq .free-gifts-header span{font-size:1.15rem;font-weight:700;color:#253D41}

#itb-add-travel-card{display:flex;gap:16px;align-items:stretch;padding:12px 0;border-top:1px solid #eee}
#itb-add-travel-card.item{margin:0}
#itb-add-travel-card .itb-media{flex:0 0 auto;display:flex;align-items:center}
#itb-add-travel-card .itb-media img{width:84px;height:84px;object-fit:contain}
#itb-add-travel-card .itb-body{display:flex;flex-direction:column;flex:1 1 auto;min-width:0;gap:6px}
#itb-add-travel-card .itb-title{font-weight:600;margin:0;width:100%;line-height:1}
#itb-add-travel-card .itb-sub{opacity:.6;margin:0;font-size:14px;color:rgba(0,0,0,.6);line-height:1}
#itb-add-travel-card .itb-tagline{margin:0;font-size:14px;color:#777544;line-height:1}
#itb-add-travel-card .itb-action-row{display:flex;align-items:center;justify-content:space-between;margin-top:auto;gap:.5rem}
#itb-add-travel-card .itb-price-row{display:flex;gap:.4rem;align-items:baseline}
#itb-add-travel-card .itb-price-now{font-weight:700;font-size:1rem;color:#000}
#itb-add-travel-card .itb-price-was{font-size:.85rem;color:#9a9a9a;text-decoration:line-through;font-weight:400}
#itb-add-travel-card .itb-add-btn{
  background:#fff;border:1px solid #B0B0B0;color:#000;
  font-size:.9rem;font-weight:700;text-transform:uppercase;
  padding:.4rem .85rem;border-radius:0;cursor:pointer;letter-spacing:.02em
}
#itb-add-travel-card .itb-add-btn:hover{background:#f5f5f5}
#itb-add-travel-card .itb-add-btn[disabled]{opacity:.6;cursor:not-allowed}
`;

  function addStyle() {
    if (document.getElementById('itb-add-travel-style')) return;
    const s = document.createElement('style');
    s.id = 'itb-add-travel-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function toggleAmpGift(hide = true){
    document.documentElement.classList.toggle('itb-hide-amp-gift', !!hide);
  }

  function container() {
    return document.querySelector('#slidecarthq .free-gifts .free-gifts-body');
  }

  /* ================== Cart state cache + helpery ================== */
  let CART_CACHE = null;
  let CART_FETCH_PROMISE = null;

  async function getCart(force = false){
    if (!force && CART_CACHE) return CART_CACHE;
    if (CART_FETCH_PROMISE) return CART_FETCH_PROMISE;
    CART_FETCH_PROMISE = fetch('/cart.js', { cache:'no-store', credentials:'same-origin' })
      .then(r => r.ok ? r.json() : { items:[] })
      .then(c => { CART_CACHE = c; return c; })
      .catch(() => ({ items:[] }))
      .finally(() => { CART_FETCH_PROMISE = null; });
    return CART_FETCH_PROMISE;
  }
  function invalidateCart(){ CART_CACHE = null; }

  function cartHasGiftType(cart, type){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => it && it.properties && it.properties._amp_gift === type);
  }

  /* ================== Odświeżenie SlideCart po /cart/add.js ================== */
  /*
     Cart drawer wystawia globalne SLIDECART_UPDATE/SLIDECART_OPEN (NIE SLIDECARTHQ).
     SLIDECART_UPDATE(callback) wykonuje pełen refresh drawera i woła callback po finiszu.
  */
  async function refreshSlideCart(){
    await new Promise((resolve) => {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        let done = false;
        try { window.SLIDECART_UPDATE(() => { done = true; resolve(); }); }
        catch(_){ resolve(); return; }
        // fallback timeout
        setTimeout(() => { if (!done) resolve(); }, 800);
      } else {
        resolve();
      }
    });

    // emit fallback eventów (gdyby były nasłuchiwane)
    ['cart:updated','itb:cart:refresh'].forEach(ev => {
      try { document.dispatchEvent(new CustomEvent(ev, { bubbles:true, cancelable:true })); } catch(_){}
    });
  }

  function cartHas50ml(cart){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => {
      const t = (it.variant_title || it.title || '').toLowerCase();
      const opts = it.options || it.variant_options || [];
      const o1 = String(opts[0] || '').toLowerCase();
      return t.includes('50ml') || o1.includes('50ml');
    });
  }

  function is50mlItem(it){
    const t = (it.variant_title || it.title || '').toLowerCase();
    const opts = it.options || it.variant_options || [];
    const o1 = String(opts[0] || '').toLowerCase();
    return t.includes('50ml') || o1.includes('50ml');
  }

  function isTravelVariant(v){
    const t = (v.title || '').toLowerCase();
    const opts = v.options || [];
    const o1 = String(opts[0] || '').toLowerCase();
    return t.includes('10ml') || o1.includes('10ml')
        || t.includes('travel') || o1.includes('travel');
  }

  function formatMoney(pence){
    return '£' + (pence / 100).toFixed(2);
  }

  const PRODUCT_CACHE = {};
  async function getProductByHandle(handle){
    if (!handle) return null;
    if (PRODUCT_CACHE[handle]) return PRODUCT_CACHE[handle];
    try {
      const r = await fetch('/products/' + encodeURIComponent(handle) + '.js', { cache:'no-store', credentials:'same-origin' });
      if (!r.ok) return null;
      const p = await r.json();
      PRODUCT_CACHE[handle] = p;
      return p;
    } catch(_){ return null; }
  }

  /*
     findTravelData — iteruje cart.items od końca (most recently added first),
     znajduje najnowszy 50ml line item, pobiera /products/{handle}.js,
     wybiera wariant travel/10ml i zwraca dane do renderu karty.
  */
  async function findTravelData(cart){
    if (!cart || !Array.isArray(cart.items)) return null;
    const items = cart.items.slice().reverse();

    for (const item of items){
      if (!is50mlItem(item)) continue;
      const handle = item.handle;
      if (!handle) continue;

      const product = await getProductByHandle(handle);
      if (!product || !Array.isArray(product.variants)) continue;

      const travel = product.variants.find(isTravelVariant);
      if (!travel) continue;

      const wasP = travel.price;
      const nowP = Math.round(wasP * 0.6);
      return {
        mainTitle: product.title,
        mainProductId: product.id,
        travelVariantId: travel.id,
        priceNow: formatMoney(nowP),
        priceWas: formatMoney(wasP)
      };
    }
    return null;
  }

  /* ================== Karta widget ================== */
  /*
     Reguła Mercedes (priorytet):
       1. Cart contains 50ml → TravelSize widget (this one)
       2. Else if 100ml → BFC50
       3. Else → none

     TravelSize jest top-priority, więc tutaj sprawdzamy tylko:
       - czy w koszyku JEST 50ml (trigger)
       - czy klient JESZCZE nie dobrał travel40 (gift już dodany)
       - snippet znalazł powiązany 10ml dla "most recently added 50ml"
  */
  // current data dla onAddClick (świeży zawsze, nie z window.__ITB_TRAVEL__)
  let CURRENT_DATA = null;

  async function ensureCard() {
    const host = container();
    if (!host) return;

    const cart = await getCart();

    // Guard 1 — klient już dobrał travel40 → ukryj.
    if (cartHasGiftType(cart, 'travel40')) {
      const existing = document.getElementById('itb-add-travel-card');
      if (existing) existing.remove();
      CURRENT_DATA = null;
      return;
    }

    // Guard 2 — brak 50ml w koszyku → ukryj.
    if (!cartHas50ml(cart)) {
      const existing = document.getElementById('itb-add-travel-card');
      if (existing) existing.remove();
      CURRENT_DATA = null;
      return;
    }

    // Dynamicznie znajdź dane (most recently added 50ml + jego travel variant)
    const data = await findTravelData(cart);
    if (!data || !data.travelVariantId) {
      const existing = document.getElementById('itb-add-travel-card');
      if (existing) existing.remove();
      CURRENT_DATA = null;
      return;
    }
    CURRENT_DATA = data;

    let el = document.getElementById('itb-add-travel-card');
    if (el) el.classList.add('item');
    if (!el) {
      el = document.createElement('div');
      el.id = 'itb-add-travel-card';
      el.classList.add('item');
      el.innerHTML = `
        <div class="itb-media">
          <img src="https://cdn.shopify.com/s/files/1/0653/7091/5035/files/100ffm.jpg" alt="Add the travel size"/>
        </div>
        <div class="itb-body">
          <div class="itb-title">Add the travel size, 40% off</div>
          <div class="itb-sub">Size: 10ml Perfume</div>
          <div class="itb-tagline">Same scent, yours for just 15 more</div>
          <div class="itb-action-row">
            <button type="button" class="itb-add-btn">ADD +</button>
            <div class="itb-price-row">
              <span class="itb-price-now">${data.priceNow || ''}</span>
              <span class="itb-price-was">${data.priceWas || ''}</span>
            </div>
          </div>
        </div>`;
      el.querySelector('.itb-add-btn').addEventListener('click', onAddClick);
    } else {
      const now = el.querySelector('.itb-price-now');
      const was = el.querySelector('.itb-price-was');
      if (now) now.textContent = data.priceNow || '';
      if (was) was.textContent = data.priceWas || '';
    }
    if (el.parentElement !== host) host.prepend(el);
  }

  async function onAddClick(e){
    e.preventDefault();
    const btn = e.currentTarget;
    const data = CURRENT_DATA;
    if (!data || !data.travelVariantId) return;

    btn.setAttribute('disabled', 'true');
    btn.textContent = 'ADDING…';
    try {
      // Bezpośrednie /cart/add.js z line item property — pozwala BFC50 widgetowi
      // wykryć stan i nasz widget zachować "single gift" zasadę.
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(data.travelVariantId),
            quantity: 1,
            properties: { _amp_gift: 'travel40' }
          }]
        }),
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('add.js failed');

      invalidateCart();
      await refreshSlideCart();
    } catch (err) {
      console.error('[AddTheTravelSize] add failed', err);
    } finally {
      btn.removeAttribute('disabled');
      btn.textContent = 'ADD +';
    }
  }

  /* ================== Boot + obserwatory ================== */
  function waitForElm(sel) {
    return new Promise(resolve => {
      const e = document.querySelector(sel);
      if (e) return resolve(e);
      const mo = new MutationObserver(() => {
        const n = document.querySelector(sel);
        if (n) { mo.disconnect(); resolve(n); }
      });
      mo.observe(document.documentElement, {childList: true, subtree: true});
    });
  }

  const debounce = (fn, t = 60) => {
    let id; return (...a) => { clearTimeout(id); id = setTimeout(() => fn(...a), t); };
  };

  function reattach() {
    if (!document.querySelector('#slidecarthq .free-gifts .free-gifts-body')) return;
    addStyle();
    invalidateCart(); // świeży fetch /cart.js przy każdej zmianie DOM slidecart
    ensureCard();
  }

  function boot() {
    addStyle();
    toggleAmpGift(true);
    ensureCard();
  }

  waitForElm('#slidecarthq .free-gifts .free-gifts-body').then(() => {
    reattach();
    const target = document.querySelector('#slidecarthq .free-gifts .free-gifts-body');
    const mo = new MutationObserver(debounce(reattach, 60));
    mo.observe(target, { childList:true, subtree:true });
  });

  ['shopify:section:load','itb:cart:refresh','cart:updated','cart:refresh','cart:changed','SLIDECARTHQ:updated'].forEach(evt => {
    const handler = () => { invalidateCart(); reattach(); };
    document.addEventListener(evt, handler, { passive:true });
    window.addEventListener(evt, handler, { passive:true });
  });

  (function watchDrawer(){
    const wait = (sel)=>new Promise(r=>{
      const e = document.querySelector(sel); if (e) return r(e);
      const mo = new MutationObserver(()=>{
        const n = document.querySelector(sel);
        if (n){ mo.disconnect(); r(n); }
      });
      mo.observe(document.documentElement,{childList:true,subtree:true});
    });
    wait('#slidecarthq').then(drawer=>{
      let t;
      const mo = new MutationObserver(()=>{
        clearTimeout(t);
        t = setTimeout(() => { reattach(); }, 120);
      });
      mo.observe(drawer, { childList:true, subtree:true });
    });
  })();

  boot();
})();
